/* Common Imports */

import React from "react";
import { styled } from "@mui/system";

/* Redux & Type Imports */

import StateInterface from "../../../redux-magic/state-interface";
import { setBroadcastFormThunk } from "../../../redux-magic/store";

/* Component Imports */

import { Typography, TextField } from "@mui/material";

/* Icon Imports */
import { NextRouter } from "next/router";
import Card from '@mui/material/Card';

/* Styled Components */

const Container = styled("div")({
	display: "flex",
	flexDirection: "column",
	justifyContent: "flex-start",
	alignItems: "center",
	width: "100%",
	height: "100%",
	minHeight: "100%",
	flex: 1,
	position: "relative",
});

const HeaderContainer = styled("div")({
	display: "flex",
	flexDirection: "column",
	justifyContent: "space-between",
	alignItems: "center",
	width: "100%",
	padding: "1rem 1rem 1rem 1rem",
	gap: "0.5rem",
	background: "#621B16",
	color: "#fff",
});

const Title = styled(Typography)({
	fontWeight: 700,
	fontSize: "1.25rem",
	textAlign: "center",
	color: "#FFFFFF",
});

const SubTitle = styled(Typography)({
	color: "#FFFFFF",
	fontWeight: 400,
	fontSize: "0.875rem",
	textAlign: "center",
});

const StyledCard = styled(Card)({
	borderRadius: "12px",
	padding: "1rem",
	width: '100%',
	height: '6rem',

})

const BorderStyled = styled("div")({
	padding: '10px',
	borderRadius: '16px',
	border: '0.5px dashed #7E7D7D',
});

const StyledTypography = styled(Typography)({
	fontWeight: 700,
	margin: "1rem 0 0 1rem",
	alignSelf: "flex-start",
});

const StyledMessage = styled(Typography)({
	fontWeight: 700,
})

export default function Summary({
	broadcast,
	dispatch,
	router,
}: {
	broadcast: StateInterface["broadcast_data"] | undefined | null;
	dispatch: Function;
	router: NextRouter;
}) {
	/* Translations */

	const localLang = {
		days: router.locale === "ar-AE" ? "يوم " : router.locale === "kn-IN" ? " ದಿನಗಳು" : " days",
		add_additional_note:
			router.locale === "ar-AE"
				? "إضافة ملاحظة إضافية"
				: router.locale === "kn-IN"
					? "ಹೆಚ್ಚುವರಿ ಟಿಪ್ಪಣಿ ಸೇರಿಸಿ"
					: "Add an additional note",
		provides_better_insight_for_agents:
			router.locale === "ar-AE"
				? "يوفر رؤية أفضل لوكلائنا."
				: router.locale === "kn-IN"
					? "ನಮ್ಮ ಏಜೆಂಟ್‌ಗಳಿಗೆ ಉತ್ತಮ ಅಂತರ್ದೃಷ್ಟಿಯನ್ನು ಒದಗಿಸುತ್ತದೆ"
					: "It helps provide better insight for the agents",
		example:
			router.locale === "ar-AE"
				? "مثال: العمولة قابلة للتفاوض ، تم إطلاقها حديثًا."
				: router.locale === "kn-IN"
					? "ಉದಾಹರಣೆ: ಬ್ರೋಕರೇಜ್‌ ಅನ್ನು ಚರ್ಚಿಸಬಹುದು, ಹೊಸದಾಗಿ ಪ್ರಾರಂಭಿಸಲಾಗಿದೆ."
					: "Eg. Commission is negotiable, Newly launched.",
		notes: router.locale === "ar-AE" ? "ملاحظات" : router.locale === "kn-IN" ? "ಟಿಪ್ಪಣಿಗಳು" : "Notes",
		immense_value:
			router.locale === "ar-AE"? "ملاحظتك لها قيمة كبيرة"
			: router.locale === "kn-IN" ? "ನಿಮ್ಮ ಟಿಪ್ಪಣಿ ಬಹಳ ಮೌಲ್ಯವಂತಿದೆ"
			: "Your note has immense value",
		add_a_note:
			router.locale === "ar-AE"? "إضافة ملاحظة"
			: router.locale === "kn-IN" ? "ಟಿಪ್ಪಣಿ ಸೇರಿಸಿ"
			: "Add a note",
	};

	return (
		<Container>
			<HeaderContainer>
				<Title variant="h6">{localLang.add_additional_note}</Title>
				<SubTitle variant="caption">{localLang.provides_better_insight_for_agents}</SubTitle>
				<BorderStyled style={{ margin: "2rem 0", backgroundColor:"#D9D9D90D"}}>
					<BorderStyled style={{backgroundColor: "#d9d9d91f"}}>
						<StyledCard>
							<Typography variant="body2">
								{localLang.notes}
							</Typography>
							<StyledMessage variant="subtitle1" style={{ fontWeight: 700 }}>
								{localLang.immense_value}
							</StyledMessage>
						</StyledCard>
					</BorderStyled>
				</BorderStyled>
			</HeaderContainer>
			<StyledTypography variant="h6">
				{localLang.add_a_note}
			</StyledTypography>
			<TextField
				placeholder={localLang.example}
				multiline
				fullWidth
				rows={10}
				value={broadcast?.notes || ""}
				onChange={(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
					const value = event.target.value;
					dispatch(
						setBroadcastFormThunk({
							commission_offered: broadcast?.commission_offered || 0,
							no_of_agents: broadcast?.no_of_agents || 0,
							notes: value || "",
						}),
					);
				}}
				sx={{
					padding: "1.5rem 1rem 1rem 1rem",
				}}
			/>
		</Container>
	);
}
